import React, { useContext, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { IoMdHome, IoMdCart, IoIosWallet } from 'react-icons/io';
import { FaLandmark, FaPlay } from 'react-icons/fa';

import { ComponentContext } from '../context/componentContext';

import { ReactComponent as FarmImg } from '../images/farms-img.svg';
import { Text, Box, PseudoBox } from '@chakra-ui/core';

const Sidebar = () => {
  const { menuOpen } = useContext(ComponentContext);

  const duration = 350;
  const buttonDuration = 550;

  const Nav = ({ link, icon, name }) => (
    <NavLink
      to={link}
      activeClassName="active-link hover:text-white"
      className="flex items-center py-2 px-4 mb-2 hover:text-cf-300 hover:border-r-4 hover:border-cf-300"
    >
      <Text as="span" className="text-base md:text-2xl md:mr-2">
        {icon}
      </Text>

      <Text
        transition={menuOpen && `all ${duration}ms ease-out`}
        as="span"
        d={{ base: 'none', md: 'block' }}
      >
        {menuOpen ? `${name}` : ''}
      </Text>
    </NavLink>
  );

  const ComingSoon = ({ name, icon }) => (
    <Fragment>
      {menuOpen && (
        <Box className="hidden md:flex items-center py-2 pl-4">
          <Text as="span" fontSize={{ base: 'base', md: '2xl' }} mr={{ md: 1 }}>
            {icon}
          </Text>
          <Text as="span" d={{ base: 'none', md: 'block' }}>
            {name}
          </Text>
          <Text
            as="span"
            d="block"
            fontSize="xx"
            bg="cf.400"
            color="white"
            rounded="sm"
            px={1}
            ml={{ md: 1 }}
          >
            coming soon
          </Text>
        </Box>
      )}
    </Fragment>
  );

  return (
    <Fragment>
      <Box
        as="nav"
        pos="fixed"
        w={{ base: 12, md: menuOpen ? 40 : 14 }}
        bg="white"
        py={20}
        fontSize="base"
        height="100vh"
        shadow={2000}
        zIndex={40}
        transition={menuOpen ? `width ${duration}ms ease-out` : `width ${duration}ms ease-in-out`}
      >
        <Box mx={{ md: 3 }} my={6}>
          <NavLink to="/tutorial">
            <PseudoBox
              as="button"
              borderWidth={{ base: 0, md: menuOpen ? 2 : 0 }}
              borderColor="cf.400"
              px={2}
              py={2}
              color="cf.400"
              mt={6}
              fontSize="xs"
              transition={
                menuOpen
                  ? `opacity ${buttonDuration}ms ease-in-out`
                  : `opacity ${buttonDuration}ms ease-in`
              }
            >
              <Text as="span" d={{ base: 'none', md: 'block' }}>
                {menuOpen ? 'Take a quick tour' : <FaPlay size="23px" />}
              </Text>
              <Text as="span" d={{ base: 'block', md: 'none' }}>
                <FaPlay size="23px" />
              </Text>
            </PseudoBox>
          </NavLink>
        </Box>
        <Box py={20} mx="auto" className="container">
          <Text as="ul" className="flex-col">
            <Nav link="/home" name="Home" icon={<IoMdHome />} />

            <Nav link="/farms" name="Farms" icon={<FarmImg />} />

            <Nav link="/orders" name="Orders" icon={<IoMdCart />} />

            {/*<Nav link="/wallet" name="Finance" icon={<IoIosWallet />} />*/}

            <ComingSoon name="Finance" />
            <ComingSoon name="Market" />
          </Text>
        </Box>
      </Box>
    </Fragment>
  );
};

export default Sidebar;
